import { Button, Input, Modal, Space } from "antd";
import React from "react";
import { useDispatch } from "react-redux";
import { useParams } from "react-router-dom/cjs/react-router-dom.min";
import { startSetLiberacionEscalamientoAsignacion } from "../../../../context/actions/escalamientoAsignacionActions";

export const ModalLiberar = ({ open, setOpen }) => {
  const dispatch = useDispatch();
  const { asistenciaID } = useParams();
  const [comentarios, setComentarios] = React.useState();

  const submit = () => {
    dispatch(
      startSetLiberacionEscalamientoAsignacion({ asistenciaID, comentarios })
    ).then(() => {
        setComentarios()
        setOpen(false)
    })
  };

  //
  return (
    <Modal
      open={open}
      title="Liberar Asignación"
      onCancel={() => setOpen(false)}
      footer={null}
    >
      <div style={{ padding: 10 }}>
        ¿Desea liberar la solicitud de escalamiento?, describa por favor de qué
        manera y con qué proveedor se continuará el servicio
      </div>
      <Input.TextArea
        onChange={({ target }) => setComentarios(target.value)}
      ></Input.TextArea>

      <div style={{ textAlign: "center" }}>
        <Space style={{ marginTop: 20 }}>
          <Button onClick={() => setOpen(false)} danger>
            Cancelar
          </Button>
          <Button disabled={!comentarios} onClick={submit} type="primary">
            Liberar Escalamiento
          </Button>
        </Space>
      </div>
    </Modal>
  );
};
